import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createCards(data) {
  return axiosInstance.post(`cards/create`, formatRequest(data));
}

export function updateCards(data) {
  return axiosInstance.post(`cards/update`, formatRequest(data));
}

export function getCardsList(data) {
  return axiosInstance.post(`cards/list`, formatRequest(data));
}

export function deleteCards(data) {
  return axiosInstance.post(`cards/delete`, formatRequest(data));
}

export function detailsCards(data) {
  return axiosInstance.post(`cards/details`, formatRequest(data));
}
